"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function User42Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "42px", height: "42px", viewBox: "0 0 42 42", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M21.000348,4 C26.5233878,4 31.0006961,8.47730832 31.0006961,14.000348 C31.0006961,17.7638281 28.9217659,21.041748 25.8496511,22.7483621 C32.3155701,24.8021666 37.000348,30.8540761 37.000348,38.000174 L35.000348,38.000348 L35.000348,38.000348 C35.000348,30.2682654 28.7322566,24.000174 21.000174,24.000174 C13.2680914,24.000174 7,30.2682654 7,38.000348 L5,38.000174 L5,38.000174 C5,30.8537317 9.68522951,24.8015833 16.1516007,22.7478167 C13.0790217,21.0418923 11,17.7639109 11,14.000348 C11,8.47730832 15.4773083,4 21.000348,4 Z M21.000174,6.00017402 C16.5817999,6.00017402 13,9.58197393 13,14.000348 C13,18.4187221 16.5817999,22.0005221 21.000174,22.0005221 C25.4185481,22.0005221 29.000348,18.4187221 29.000348,14.000348 C29.000348,9.58197393 25.4185481,6.00017402 21.000174,6.00017402 Z", id: `user42-${id0}` })),
        react_1.default.createElement("g", { id: "user-42", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                react_1.default.createElement("use", { xlinkHref: `#user42-${id0}` })),
            react_1.default.createElement("use", { id: "Combined-Shape", fill: "#000000", fillRule: "nonzero", xlinkHref: `#user42-${id0}` })));
}
function User42(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(User42Svg, Object.assign({}, svgProps)));
}
exports.default = User42;
//# sourceMappingURL=User42.js.map